import { motion, useReducedMotion } from 'framer-motion';
import { CTA } from './Common';

export const Hero = () => {
  const reduced = useReducedMotion();
  const enter = delay => ({
    initial: reduced ? false : { opacity: 0, y: 18 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: .7, delay, ease: [.22, 1, .36, 1] },
  });
  return <section className="collective-hero" id="inicio" data-testid="hero-section">
    <div className="collective-stage">
      <picture className="collective-media">
        <source media="(max-width: 700px)" srcSet="/images/collaborators-hero-mobile.webp" />
        <img src="/images/collaborators-hero.webp" alt="Equipo de colaboradores compartiendo ideas alrededor de un computador en una oficina moderna" width="2000" height="1125" fetchPriority="high" data-testid="hero-team-photo" />
      </picture>
      <div className="collective-scrim" aria-hidden="true" />
      <div className="collective-content container">
        <div className="collective-copy">
          <motion.h1 className="collective-heading" data-testid="hero-heading" {...enter(.14)}>
            <span data-testid="hero-heading-primary"><span className="collective-heading-highlight" data-testid="hero-heading-protection">Protege a tu equipo</span> con lo que realmente necesita, </span><span data-testid="hero-heading-price">al mejor precio.</span>
          </motion.h1>
          <motion.div {...enter(.38)}>
            <p className="collective-description" data-testid="hero-description">La primera empresa que asegura, protege y entrega <strong data-testid="hero-description-benefits">beneficios a medida</strong> para colaboradores y <strong data-testid="hero-description-families">extendibles a sus familias</strong> (algunos sin costo para la empresa).</p>
            <p className="collective-closing" data-testid="hero-closing">Con precios y <strong data-testid="hero-closing-conditions">condiciones de grandes empresas</strong> para todo tipo de equipos.</p>
            <p className="collective-cta-message" data-testid="hero-saving-reminder">No pagues de más por beneficios que nadie usa!</p>
            <div className="collective-actions">
              <CTA id="hero-review-cta" href="#asesoria" className="collective-primary">Solicita tu revisión y asesoría 360</CTA>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
    <Insurers />
  </section>;
};

export const Insurers = () => <section className="insurers collective-insurers" data-testid="insurers-section"><div className="container insurers-inner"><p data-testid="insurers-title">TU EQUIPO ES IMPORTANTE.<br /><strong>SU PROTECCIÓN TAMBIÉN.</strong><span>Principales aseguradoras de Chile.</span></p><div className="insurer-logos">{[['mapfre', 'MAPFRE'], ['bci', 'BCI Seguros'], ['sura', 'SURA'], ['zurich', 'Zurich'], ['hdi', 'HDI Seguros'], ['reale', 'Reale Seguros'], ['renta', 'Renta Nacional']].map(([id, name]) => <img key={id} src={`/images/partner-${id}.png`} alt={name} data-testid={`insurer-logo-${id}`} loading="lazy" />)}</div></div></section>;